import { getDirectorsFromCHCompany } from '../../api/client'
import { companyAutocomplete, companyDetail } from '../../api_companies_house/methods'
import { Resolvers } from '../../generated/resolvers'

const CompaniesHouseResolver: Resolvers = {
  Query: {
    companyAutocomplete: async (_, params) => await companyAutocomplete(params.input),
    getCompanyDetail: async (_, params) => await companyDetail(params.companyId),
    getDirectorsFromCHCompany: async (_, { company, organisation_id }) => await getDirectorsFromCHCompany(company, organisation_id),
  },
}

export default CompaniesHouseResolver
